import React from 'react';
import { IconCancel, IconCircleCheck } from 'gatorcomponents';

const iconCheck = <IconCircleCheck color="activeLight" />;
const iconCancel = <IconCancel color="problemPure" />;

export default {
  studio: 'HostGator Studio Pro',
  bannerPlans: {
    title: 'Prueba el plan Pro y crea diseños profesionales',
    titleTrial: 'Prueba el plan Pro gratis por 7 días',
    subtitle: 'Cancela en cualquier momento. Te recordaremos antes de que termine la prueba.',
  },
  headerDesc: {
    title: '¡Crea como un profesional con el Pro!',
    subtitle: (
      <>
        Desbloquea la herramienta Pro
        <br />
        para impulsar tu marca.
      </>
    ),
    planType: 'Tipo de plan:',
    planRecurrence: 'Mensual',
  },
  planFree: {
    priceDesc: 'Gratis con tu plan',
  },
  planPro: {
    trial: '7 días gratis',
    name: 'Studio Pro',
    priceDesc: price => `${price} año`,
    recurrence: 'mes',
    buttonLabel: 'Contratar plan',
  },
  tablePlan: [
    {
      id: 1,
      desc: 'Plantillas gratuitas en diferentes formatos',
      free: {
        desktop: iconCheck,
        mobile: (
          <>
            {iconCheck}
            Plantillas gratuitas en diferentes formatos
          </>
        ),
      },
      pro: {
        desktop: iconCheck,
        mobile: (
          <>
            {iconCheck}
            Plantillas gratuitas en diferentes formatos
          </>
        ),
      },
    },
    {
      id: 2,
      desc: 'Filtros, fuentes y plantillas premium',
      free: {
        desktop: iconCancel,
        mobile: (
          <>
            {iconCancel}
            Filtros, fuentes y plantillas premium
          </>
        ),
      },
      pro: {
        desktop: iconCheck,
        mobile: (
          <>
            {iconCheck}
            Filtros, fuentes y plantillas premium
          </>
        ),
      },
    },
    {
      id: 3,
      desc: 'Creación de kit de marca (logo, colores y fuentes de la marca)',
      free: {
        desktop: iconCancel,
        mobile: (
          <>
            {iconCancel}
            Creación de kit de marca (logo, colores y fuentes de la marca)
          </>
        ),
      },
      pro: {
        desktop: iconCheck,
        mobile: (
          <>
            {iconCheck}
            Creación de kit de marca (logo, colores y fuentes de la marca)
          </>
        ),
      },
    },
    {
      id: 4,
      desc: 'Creador de logos con IA',
      free: {
        desktop: '10 créditos por mes',
        mobile: (
          <>
            {iconCheck}
            Creador de logos con IA
            <br />
            <small>10 créditos por mes</small>
          </>
        ),
      },
      pro: {
        desktop: '75 créditos por mes',
        mobile: (
          <>
            {iconCheck}
            Creador de logos con IA
            <br />
            <small>75 créditos por mes</small>
          </>
        ),
      },
    },
    {
      id: 5,
      desc: 'Eliminación de fondo con IA',
      free: {
        desktop: iconCancel,
        mobile: (
          <>
            {iconCancel}
            Eliminación de fondo con IA
          </>
        ),
      },
      pro: {
        desktop: '75 créditos por mes',
        mobile: (
          <>
            {iconCheck}
            Eliminación de fondo con IA
          </>
        ),
      },
    },
    {
      id: 6,
      desc: 'Banco de imágenes, íconos, fuentes y otros recursos',
      free: {
        desktop: iconCheck,
        mobile: (
          <>
            {iconCheck}
            Banco de imágenes, íconos, fuentes y otros recursos
          </>
        ),
      },
      pro: {
        desktop: iconCheck,
        mobile: (
          <>
            {iconCheck}
            Banco de imágenes, íconos, fuentes y otros recursos
          </>
        ),
      },
    },
    {
      id: 7,
      desc: 'Optimización de imágenes',
      free: {
        desktop: iconCancel,
        mobile: (
          <>
            {iconCancel}
            Optimización de imágenes
          </>
        ),
      },
      pro: {
        desktop: iconCheck,
        mobile: (
          <>
            {iconCheck}
            Optimización de imágenes
          </>
        ),
      },
    },
    {
      id: 8,
      desc: 'Dimensiones personalizadas',
      free: {
        desktop: iconCheck,
        mobile: (
          <>
            {iconCheck}
            Dimensiones personalizadas
          </>
        ),
      },
      pro: {
        desktop: iconCheck,
        mobile: (
          <>
            {iconCheck}
            Dimensiones personalizadas
          </>
        ),
      },
    },
    {
      id: 9,
      desc: 'Editor exclusivo',
      free: {
        desktop: 'Funciones básicas',
        mobile: (
          <>
            {iconCheck}
            Editor exclusivo - Funciones básicas
          </>
        ),
      },
      pro: {
        desktop: 'Funciones avanzadas',
        mobile: (
          <>
            {iconCheck}
            Editor exclusivo - Funciones avanzadas
          </>
        ),
      },
    },
    {
      id: 10,
      desc: 'Descarga en alta resolución',
      free: {
        desktop: 'Limitado',
        mobile: (
          <>
            {iconCheck}
            Descarga en alta resolución - Limitado
          </>
        ),
      },
      pro: {
        desktop: 'Ilimitado',
        mobile: (
          <>
            {iconCheck}
            Descarga en alta resolución - Ilimitado
          </>
        ),
      },
    },
  ],
  buttonShowMore: 'Mostrar más',
  buttonShowLess: 'Mostrar menos',
};
